import { Outlet } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { useContext} from 'react'
import RootContext from '../context/RootContext'
import GoogleTranslate from '../services/GoogleTranslate'
import WhatsappWidget from './Widget/WhatsappWidget'


const FrontendLayout = () => {
  const {isTranslating } = useContext(RootContext)


  return (
    <div id="main-content">
      <Header />
      <main id='page-content'   onClick={() => window.__closeMobileMenu?.()}>
        {isTranslating && (
          <div className='text-muted text-center'>Translating...</div>
        )}
        <GoogleTranslate />
        <Outlet />
        <WhatsappWidget />
      
      </main>
      <Footer />
    </div>
  )
}

export default FrontendLayout
